import { jsx as y } from "react/jsx-runtime";
import { a as b, c as d } from "../../vendor-D9Nsxj9p.js";
import { forwardRef as f } from "react";
import { injectSpacingClasses as l } from "../../utils/injectSpacingClasses/index.js";
import { omit as g } from "../../utils/omit/index.js";
import '../../assets/index6.css';const q = "V6JZKq_baseButton", B = "V6JZKq_destructive", J = "V6JZKq_ghost", K = "V6JZKq_primary", V = "V6JZKq_secondary", s = {
  baseButton: q,
  destructive: B,
  ghost: J,
  "night-aware": "V6JZKq_night-aware",
  primary: K,
  secondary: V
}, w = f(
  ({ variant: o = "primary", children: r, className: e, m: a, mt: c, mr: n, mb: i, ml: m, ...p }, u) => {
    const t = {
      [s.baseButton]: !0,
      [s[o]]: !0
    };
    return l(t, { m: a, mt: c, mr: n, mb: i, ml: m }), /* @__PURE__ */ y(
      b,
      {
        className: d(t, e),
        ...g(p, ["className", "style", "slot", "type"]),
        type: "button",
        ref: u,
        children: r
      }
    );
  }
);
export {
  w as BaseButton
};
//# sourceMappingURL=index.js.map
